import { render } from "./create_org.vue?vue&type=template&id=5994ac09&scoped=true"
import script from "./create_org.vue?vue&type=script&lang=js"
export * from "./create_org.vue?vue&type=script&lang=js"

import "./create_org.vue?vue&type=style&index=0&id=5994ac09&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5994ac09"]])

export default __exports__